/**
 * Pinned hero — spacer senkronu. Primitif: assets/aycan-sections.css `.aycan-pin`
 *
 * Yapılan tek iş şu: sabit (position:fixed) hero akıştan hiç yer kaplamaz, o yüzden
 * yerini bir spacer tutar. Spacer'ın yüksekliği = hero yüksekliği − host'un belge
 * üstünden uzaklığı. Hero viewport 0'dan çizilirken host header grubunun ALTINDAN
 * başladığı için, tam boy bir spacer alttaki bölümü o kadar aşağı iter ve
 * bindirme yerine boşluk bırakır.
 *
 * Ofset canlı ölçülür (scroll'dan bağımsız), böylece header yüksekliğinin değiştiği
 * her breakpoint'te doğru kalır. CSS `--pin-head` ile yakın bir JS-öncesi değer
 * verir; burası onu kesinleştirir.
 *
 * Tek dosya, tek uygulama: hangi section kullanırsa kullansın (aycan-pinned-hero,
 * aycan-support-hub) aynı matematik çalışır — sayfa başına JS yazılmaz.
 */
(function () {
  'use strict';

  var HOSTS = '.aycan-pin-host, .aycan-pin-sec';
  var observed = new WeakMap();

  /* Header grubunun AKIŞ yüksekliği. offsetHeight kullanılıyor, rect değil:
     header sticky, yani sayfa kaydırılmışken rect'i belge üstünü göstermez ama
     akıştaki yeri sabit kalır. Hero belge 0'dan çizildiği için hero'nun bu kadar
     üst bandı header'ın altında kalır — CSS bunu --pin-head-h ile boşluğa çevirip
     içeriğin oraya düşmesini engelliyor. */
  function headerHeight() {
    var els = document.querySelectorAll('.shopify-section-group-header-group');
    var h = 0;
    for (var i = 0; i < els.length; i++) h += els[i].offsetHeight;
    return h;
  }

  /* Opt-in (`.aycan-pin--fit-next` on the hero element, set by a section
     checkbox — currently only aycan-pinned-hero/custom-orders): shrink the
     hero so it plus the very next riding section together fill exactly one
     screen. The static --pin-h-{sm,md,lg} token is width-floored (42/50/55vw),
     so it barely shrinks on a short-but-wide window — measured live at
     1440×900 vs 1440×760, the "sm" token gave 611px both times, leaving the
     3-step row cut off on the shorter one. This computes the real number
     instead of hoping a fixed token lines up.

     Desktop only: the riding section stacks tall on mobile (steps go from a
     row to 3 stacked blocks), so "fit both in one screen" isn't achievable
     there without crushing the hero — the static token governs on mobile,
     same as before this existed.

     No feedback loop: riding's own height depends on its content and a
     width-based margin-top, neither of which this function touches, so
     recomputing after the ResizeObserver fires below is idempotent. */
  function fitToNextSection(host, hero) {
    if (window.innerWidth < 750) return;
    var riding = host.classList.contains('aycan-pin-sec')
      ? host.nextElementSibling
      : host.querySelector('.aycan-pin-up');
    if (!riding) return;
    var marginTop = parseFloat(getComputedStyle(riding).marginTop) || 0;
    var remPx = parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;
    /* Floor matches --pin-h-sm's own internal rem floor (32rem + 12rem) — the
       smallest this hero's content has been measured to sit comfortably in. */
    var minPinH = 44 * remPx;
    var target = window.innerHeight - riding.offsetHeight - marginTop;
    host.style.setProperty('--pin-h', Math.max(minPinH, Math.round(target)) + 'px');
  }

  function sync(host) {
    var hero = host.querySelector('.aycan-pin');
    var spacer = host.querySelector('.aycan-pin__spacer');
    if (!hero || !spacer) return;
    var head = headerHeight();
    if (head > 0) host.style.setProperty('--pin-head-h', head + 'px');
    if (hero.classList.contains('aycan-pin--fit-next')) fitToNextSection(host, hero);
    /* Ofset SPACER'ın kendi belge konumundan okunuyor, host'unkinden değil:
       host'un kendi padding/margin'i varsa (ör. section ayarından gelen
       padding-top) ikisi ayrışır ve spacer o kadar uzun kalıp gövdeyi aşağı
       iter. Spacer'ın üst konumu kendi yüksekliğinden etkilenmediği için bunu
       yüksekliği değiştirmeden önce okumak da gerekmiyor. */
    var offset = spacer.getBoundingClientRect().top + window.scrollY;
    spacer.style.blockSize = Math.max(0, Math.round(hero.offsetHeight - offset)) + 'px';
  }

  function syncAll() {
    document.querySelectorAll(HOSTS).forEach(sync);
  }

  /* Hero'nun kendi yüksekliği viewport'a bağlı (clamp/vh/vw) ve içeriği fontlarla
     birlikte büyüyebilir. ResizeObserver ikisini de yakalar; `resize` ise header
     yüksekliği değiştiğinde ofseti tazeler. */
  function observe(host) {
    if (observed.has(host) || typeof ResizeObserver === 'undefined') return;
    var hero = host.querySelector('.aycan-pin');
    if (!hero) return;
    var ro = new ResizeObserver(function () {
      sync(host);
    });
    ro.observe(hero);
    observed.set(host, ro);
  }

  function boot() {
    document.querySelectorAll(HOSTS).forEach(function (host) {
      sync(host);
      observe(host);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('resize', syncAll);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncAll);
  // Tema editöründe bir section yeniden yüklenince ofset de değişebilir.
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', syncAll);
})();
